import { useCallback } from 'react';
import { useApiGestao } from 'servicos/api-gestao/base';

export function useUsuarioExiste() {
  const { invocarApi, ...resto } = useApiGestao();

  const verificarSeUsuarioExiste = useCallback(
    async (email: string) =>{
      const ret = await invocarApi({
        url: `usuario/exists/${btoa(email)}`,
        enviarTokenIntegracao: true
      });

      let retError = {};
      //ERRO NO TOKEN
      if (ret.statusCode === 401) {
        retError = await invocarApi({
          url: `usuario/exists/${btoa(email)}`,
          enviarTokenIntegracao: true,
          forcarTokenIntegracao: true
        });
      }
      return { ...ret, ...retError };
    }
    ,
    [invocarApi]
  );

  return {
    ...resto,
    verificarSeUsuarioExiste,
  };
}
